import {Module} from "vuex";
import {RooteState} from "@/store/index";

export interface ModalsState{
  modals: string[]
}

export const modals : Module<ModalsState, RooteState> =  {
  namespaced: true,
  state: () => ({
    modals: [] // 현재 열려 있는 모든 모달을 저장하는 배열
  }),
  mutations: {
    openModal(state, name: string) {
      if (!state.modals.some(modal => modal === name)) {
        state.modals.push(name);
      }
    },
    closeModal(state, currentModalName: string) {
      state.modals = state.modals.filter(modal => modal !== currentModalName);
    }
  },
  actions: {
    openModal({ commit }, payload) {
      commit("openModal", payload);
    },
    closeModal({ commit }, modalId) {
      commit("closeModal", modalId);
    }
  },
  getters: {
    allModals: (state) => state.modals,  // 모든 모달 정보 반환
    topModal: (state) => state.modals.length > 0 ? state.modals[state.modals.length - 1] : null // 최상단 모달
  }
};
